import React, { useEffect, useMemo, useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import './dashboard-tabs.scss';
import classnames from 'classnames';
import TripsList from './TripsList';
import ReportsList from './ReportsList';
import PendingTripsList from './PendingTripsList';
import PendingReportsList from './PendingReportsList';

interface DashboardTabsProps {
  currentView: string;
  subTabPermissionList?: string[];
}

const DashboardTabs: React.FC<DashboardTabsProps> = ({
  currentView,
  subTabPermissionList = [],
}) => {
  const [activeTab, setActiveTab] = useState('first');

  const employeeTabs = useMemo(
    () =>
      [
        subTabPermissionList.includes('trips')
          ? { id: 'first', title: 'Trips' }
          : null,
        subTabPermissionList.includes('reports')
          ? { id: 'second', title: 'Reports' }
          : null,
      ].filter(Boolean) as { id: string; title: string }[],
    [subTabPermissionList],
  );

  const approverTabs = [
    subTabPermissionList.includes('approvals_trips')
      ? { id: 'first', title: 'Pending Trips' }
      : null,
    subTabPermissionList.includes('approvals_reports')
      ? { id: 'second', title: 'Pending Expense Reports' }
      : null,
  ].filter(Boolean) as { id: string; title: string }[];

  const tabs = currentView === 'employee' ? employeeTabs : approverTabs;

  useEffect(() => {
    if (tabs.length > 0 && !tabs.some((tab) => tab.id === activeTab)) {
      setActiveTab(tabs[0].id);
    }
  }, [activeTab, tabs]);

  const toggle = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const renderTabContent = (tabId: string, title: string) => {
    if (currentView === 'employee') {
      if (tabId === 'first') {
        return <TripsList />;
      } else {
        return <ReportsList />;
      }
    } else {
      if (tabId === 'first') {
        return <PendingTripsList />;
      } else {
        return <PendingReportsList />;
      }
    }
  };

  return (
    <div className="dashboard-tabs">
      {tabs.length === 0 ? null : (
        <>
          <div className="tabs-container">
            <Nav pills className="mb-0">
              {tabs.map((tab) => (
                <NavItem key={tab.id}>
                  <NavLink
                    className={classnames({ active: activeTab === tab.id })}
                    onClick={() => toggle(tab.id)}
                  >
                    {tab.title}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </div>
          <TabContent activeTab={activeTab}>
            {tabs.map((tab) => (
              <TabPane key={tab.id} tabId={tab.id}>
                {renderTabContent(tab.id, tab.title)}
              </TabPane>
            ))}
          </TabContent>
        </>
      )}
    </div>
  );
};

export default DashboardTabs; 
